export default class CreatePurchaseOrder {
    note:string;
    contactPhone:string;
    contactName:string;
    warehouseCode:string;
    shippingDate:Date;
    assetTypeCode :string;
    conditionTypeCode:string;
    srcClientBranchId: number;
    externalCode:string;
    type: string;
    returnSoId :number;
    supplierCode :string;
    clientCode:string;
    items :Array<any>;
    id:number;
    code:string;
    clientName:string;
    statusName:string;
    returnSoCode :string;
    assetTypeName :string;
    conditionTypeName:string;
    containerNumber :string;
    invoiceNumber:string;
    invoiceDate:Date;
    productType:string;
    externalSoId :number;
    externalSoCode : string;
}